// extracted by mini-css-extract-plugin
export default {"spinner-content":"ClaimDepartment_spinner-content__5JmJI","spinner":"ClaimDepartment_spinner__otz+E"};